$(document).on('click', '[data-modal-open]', function () {
    const $this = $(this);
    const popup = $this.attr('href');
    const $popup = $('[data-modal="' + popup + '"]');
    const $body = $('body');

    if ($popup.length) {
        ['phone', 'name', 'email'].forEach(function (field) {
            const fieldValue = $body.data('user-' + field);
            const $field = $popup.find('.user_' + field + '_field');

            if ($field.length && typeof fieldValue !== 'undefined') {
                $field.val(fieldValue);
                $field.addClass('valid');
                $field.closest('.js-field').removeClass('field__error');
                $field[0].dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }
});

$(document).on('click', '[data-modal-open][href="#order-install"]', function () {
    const $this = $(this);
    const popup = $this.attr('href').replace('#', '');
    const modelValue = $this.data('model');
    const serialNumberValue = $this.data('serial-number');
    const productIdValue = $this.data('product-id');
    const productNameValue = $this.data('product-name');
    const articleValue = $this.data('article');
    const eanValue = $this.data('ean');
    const cityValue = $this.data('city');
    const $popup = $('[data-modal="#' + popup + '"]');

    if (!$popup.length) {
        return;
    }

    const $model = $popup.find('.model');
    const $serialNumber = $popup.find('.serial_number');
    const $productId = $popup.find('.product-id');
    const $article = $popup.find('.article');
    const $ean = $popup.find('.ean');

    if ($model.length && typeof modelValue !== 'undefined') {
        $model.val(modelValue);
        $model.addClass('valid');
        $model.closest('.js-field').removeClass('field__error');
        $model[0].dispatchEvent(new Event('change', { bubbles: true }));
    }

    if ($serialNumber.length && typeof serialNumberValue !== 'undefined') {
        $serialNumber.val(serialNumberValue);
        $serialNumber.addClass('valid');
        $serialNumber.closest('.js-field').removeClass('field__error');
        $serialNumber[0].dispatchEvent(new Event('change', { bubbles: true }));
    }

    if ($productId.length && typeof productIdValue != 'undefined') {
        $productId.val(productIdValue);
    }

    if ($article.length && typeof articleValue !== 'undefined') {
        $article.val(articleValue);
    }

    if ($ean.length && typeof eanValue !== 'undefined') {
        $ean.val(eanValue);
    }

    if ($productId.length && typeof productIdValue !== 'undefined') {
        window.productSearchPanel.resetForm($popup.find('form'));
        window.productSearchPanel.insertSelectedItem($popup.find('form'), productIdValue, modelValue, productNameValue, cityValue, serialNumberValue);
    }
});
